import { node, text } from "~/util/dom";
import { CONFIG } from "~/config";
import { _ } from "~/i18n";
import { v4 as uuidv4 } from "uuid";

interface IDeepLData {
	text?: string;
	lang: string;
	container: HTMLElement;
	native: boolean;
}

interface ITranslateData {
	posible: boolean;
	translatedText?: string;
}

interface IResponse {
	code: number;
	message: string;
	text?: string;
}

export function createDOMElements() {
	const container = node("p", { className: "deepl" });
	const button = node("button", { className: "deepl-btn" }, _("deepl.button"));
	const origButton = node("button", {}, _("deepl.original"));
	const translateButton = node("button", { className: "nonactive" }, _("deepl.translate"));

	button.setAttribute("data-log-ignore", "1");
	origButton.setAttribute("data-log-ignore", "1");
	translateButton.setAttribute("data-log-ignore", "1");

	return {
		container,
		button,
		origButton,
		translateButton,
	};
}

function callRequest(txt: string) {
	const REQUEST_URL = `${CONFIG.requestUrl}/translate`;

	return fetch(REQUEST_URL, {
		headers: {
			"Accept": "application/json",
			"Content-Type": "application/json",
			"X-Correlation-Id": uuidv4(),
		},
		credentials: "include",
		method: "POST",
		body: JSON.stringify({
			text: txt,
			lang: Mapy.CUS.userweb.deeplLang || CONFIG.defaultLang,
		}),
	});
}

function translateTexts(texts: Array<string> = []): Array<Promise<IResponse>> {
	const promiseArray = [];

	texts.forEach(txt => {
		if (txt) {
			// eslint-disable-next-line no-async-promise-executor
			promiseArray.push(new Promise(async (resolve, reject) => {
				const response = await callRequest(txt);

				if (response.status === 200) {
					const json = await response.json();

					json ? resolve(json) : reject();
				} else {
					reject();
				}

				resolve("");
			}));
		} else {
			promiseArray.push(Promise.resolve(""));
		}
	});

	return promiseArray;
}

function switchTranslate(data: Array<IDeepLData>, translateData: Array<ITranslateData>, elements: {
	button: HTMLButtonElement,
	origButton: HTMLButtonElement,
	translateButton: HTMLButtonElement,
	container: HTMLParagraphElement,
 }, orig: boolean, native: boolean) {
	data.forEach((item, index) => {
		if (item.container) {
			item.container.innerHTML = native
				? orig
					? translateData[index].translatedText
					: item.text
				: orig
					? item.text
					: translateData[index].translatedText;
		}
	});

	elements.container.innerHTML = "";

	if (orig) {
		elements.container.appendChild(elements.translateButton);
		elements.container.appendChild(text(" · "));
		elements.container.appendChild(elements.origButton);
	} else {
		elements.container.appendChild(elements.button);
	}
}

export function createDeepLTranslate(data: Array<IDeepLData> | IDeepLData, type = "", changeCb?: (translate?: boolean) => void): HTMLParagraphElement {
	const { container, button, origButton, translateButton } = createDOMElements();
	const translateData: Array<ITranslateData> = [];
	const arrayData = Array.isArray(data) ? data : [data];
	const native = arrayData[0].native || !("native" in arrayData[0]);
	let showButton = false;
	const loading = node("span", {}, _("deepl.loading"));
	const showOtherlanguage = async (original: boolean) => {
		container.innerHTML = "";
		container.appendChild(loading);

		try {
			const textsTrans = translateData.map((item, index) => item.posible && arrayData[index].text ? arrayData[index].text : "");

			if (!translateData[0].translatedText) {
				const translatedText = await Promise.allSettled(translateTexts(textsTrans));

				translatedText.forEach((trans, index) => {
					if (trans.status === "fulfilled" && trans.value?.text) {
						translateData[index].translatedText = trans.value.text;
					}
				});

				Mapy.getComponent("logger").log("translate", {
					type,
				});
			}

			switchTranslate(arrayData, translateData, {
				button,
				origButton,
				translateButton,
				container,
			}, original, native);

			changeCb && changeCb(true);
		} catch (exception) {
			// eslint-disable-next-line no-console
			console.log("DeepL translate error:", exception);
			container.innerHTML = "";
			if (original) {
				container.appendChild(button);
			} else {
				container.appendChild(translateButton);
				container.appendChild(text(" · "));
				container.appendChild(origButton);
			}
		}
	};

	arrayData.forEach(item => {
		if (!showButton) {
			showButton = item.lang !== (Mapy.CUS.userweb.deeplLang || CONFIG.defaultLang);
		}

		translateData.push({
			posible: item.lang && item.lang !== (Mapy.CUS.userweb.deeplLang || CONFIG.defaultLang),
		});
	});

	if (showButton) {
		// pokud je text v rodnem jazyce, zobrazime tlacitko prelozit
		if (native) {
			container.appendChild(button);
			button.addEventListener("click", () => {
				showOtherlanguage(native);
			}, false);
			origButton.addEventListener("click", () => {
				switchTranslate(arrayData, translateData, {
					button,
					origButton,
					translateButton,
					container,
				}, false, native);

				changeCb && changeCb();
			});
		// pokud neni v rodnem jazyce, zobrazime info o automatickem prekladu a tlacitka puvodniho jazyka
		} else {
			container.appendChild(translateButton);
			container.appendChild(text(" · "));
			container.appendChild(origButton);
			origButton.addEventListener("click", () => {
				showOtherlanguage(native);
			}, false);
			button.addEventListener("click", () => {
				switchTranslate(arrayData, translateData, {
					button,
					origButton,
					translateButton,
					container,
				}, true, native);

				changeCb && changeCb();
			});
		}

		return container;
	}

	/*if (showButton) {
		button.addEventListener("click", () => {
			const loading = node("span", {}, _("deepl.loading"));

			button.remove();
			container.appendChild(loading);

			const textsTrans = translateData.map((item, index) => item.posible && arrayData[index].text ? arrayData[index].text : "");
			let haveTranslateText = false;

			Promise.allSettled(translateTexts(textsTrans)).then(translatedText => {
				translatedText.forEach((trans, index) => {
					if (trans.status === "fulfilled" && trans.value?.text) {
						translateData[index].translatedText = trans.value.text;
						haveTranslateText = true;
					}

					switchTranslate(arrayData, translateData, {
						button,
						origButton,
						translateButton,
						container,
					});
				});

				if (haveTranslateText) {
					origButton.addEventListener("click", () => {
						!origButton.classList.contains("nonactive") && switchTranslate(arrayData, translateData, {
							button,
							origButton,
							translateButton,
							container,
						}, true);

						changeCb && changeCb();
					}, false);

					translateButton.addEventListener("click", () => {
						!translateButton.classList.contains("nonactive") && switchTranslate(arrayData, translateData, {
							button,
							origButton,
							translateButton,
							container,
						});

						changeCb && changeCb(true);
					}, false);

					changeCb && changeCb(true);
				} else {
					container.innerHTML = "";
					container.appendChild(button);
					container.appendChild(text(" · "));
					container.appendChild(node("i", {}, _("deepl.error")));
				}

				Mapy.getComponent("logger").log("translate", {
					type,
				});
			}, exception => {
				// eslint-disable-next-line no-console
				console.log("DeepL translate error:", exception);
				container.innerHTML = "";
				container.appendChild(button);
			});
		}, false);

		container.appendChild(translateButton);
		container.appendChild(text(" · "));
		container.appendChild(origButton);

		return container;
	}*/

	return null;
}
